import { CheckIcon } from "@heroicons/react/solid";
import { useMemo } from "react";

import { FilterDropDown } from "@/features/common/components/filter/FilterDropDown";
import { usePreApplyWhereQuery } from "@/features/common/hooks/usePreApplyWhereQuery";
import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";

export const MultiEnumFilter = <WHERE, ORDER_BY>({
  label,
  name,
  options,
}: {
  label: string;
  name: string;
  options: any[];
}) => {
  const { preApplyWhere, setPreApplyWhere } = usePreApplyWhereQuery<WHERE>();
  const { query, setWhere } = useRequestQuery<WHERE, ORDER_BY>();
  const selectedEnums = preApplyWhere?.[name]?.in;

  const handleSelect = (item: string) => {
    const updateValue = selectedEnums?.includes(item)
      ? selectedEnums?.filter((value) => value !== item)
      : [...(selectedEnums ?? []), item];

    setPreApplyWhere({
      ...preApplyWhere,
      [name]: { in: updateValue },
    } as unknown as WHERE);
  };

  const appliedEnums = useMemo(
    () =>
      query?.where?.[name]?.in?.map(
        (value) => options.find((option) => option.name === value)?.label,
      ),
    [query],
  );

  return (
    <FilterDropDown
      value={appliedEnums}
      onApply={() => setWhere(preApplyWhere)}
      onClear={() => setWhere({ ...preApplyWhere, [name]: undefined })}
      renderChip={({ value }) => (
        <span>{label + (value ? `: ${value}` : "")}</span>
      )}
      filterOptionItem={
        <div>
          {options?.map((option, index) => (
            <div
              key={index}
              className="flex cursor-pointer items-center justify-between rounded-md p-2 text-sm font-normal leading-5 text-gray-700 hover:bg-blue-50"
              onClick={() => handleSelect(option.name)}
            >
              {option.label}
              {selectedEnums?.includes(option.name) && (
                <CheckIcon className="text-primary h-4 w-4" />
              )}
            </div>
          ))}
        </div>
      }
    />
  );
};
